import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language_code: 'en',
  },
  mutations: {
    setLanguageCode(state, value) {
      state.language_code = value
    },
  },
  modules: {
    auth,
  },
})
